import { useContext } from 'react';
import {
  NotificationContext,
  NotificationContextType,
} from './providers/useNotificationProvider';

const useNotification = (): NotificationContextType =>
  useContext(NotificationContext);

export default useNotification;
